import Vue from 'vue'
/* Element UI lang */
import elementEnLocale from 'element-ui/lib/locale/lang/en'

import VueI18n from 'vue-i18n'
import { APP_DEFAULT_LOCALE } from '../utils/const'

/* Locale */
import enLocale from './en'

Vue.use(VueI18n)

// Keep track of what language we have downloaded to prevent extra downloads.
const loadedLanguages = [APP_DEFAULT_LOCALE]

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale,
  },
}

export const i18n = new VueI18n({
  locale: APP_DEFAULT_LOCALE,
  fallbackLocale: APP_DEFAULT_LOCALE,
  messages,
})

function setI18nLanguage(locale) {
  i18n.locale = locale
}

/**
 * Lazy load the requested language to the app and display
 * @param {string} locale
 */
export function lazyLoadLanguageAsync(locale) {
  return new Promise((resolve, reject) => {
    // Nothing changes
    if (i18n.locale === locale) {
      return resolve()
    }

    // use the downloaded language file
    if (loadedLanguages.includes(locale)) {
      setI18nLanguage(locale)
      return resolve()
    }

    // Download the requested language for app and element-ui
    const localeFile = `./${locale}`
    const elementLocaleFile = `element-ui/lib/locale/lang/${locale}`
    Promise.all([
      import(localeFile),
      import(elementLocaleFile),
    ]).then((results) => {
      const appLocal = results[0]
      const elementLocal = results[1]

      i18n.setLocaleMessage(locale, {
        ...appLocal.default,
        ...elementLocal.default,
      })

      loadedLanguages.push(locale)
      setI18nLanguage(locale)

      return resolve()
    }).catch(error => reject(error))

    return resolve()
  })
}
